// @core/api/endpoints/context/get_user_context_preferences.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUserContextPreferencesResponse,
} from '../../../types/context';

const BASE_PATH = '/context';

/**
 * Get user context preferences
 * Returns the current user's Context Panel preferences including explicit section ordering, hidden sections, and behavior data.
 */
export async function GetUserContextPreferences(
  params?: {
  },
  options?: RequestOptions
): Promise<GetUserContextPreferencesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/context/config/user`;
  const requestOptions = options;
  return client.get<GetUserContextPreferencesResponse>(requestPath, { ...requestOptions, params });
}
